import { render, staticRenderFns } from "./LoginPhone.vue?vue&type=template&id=6a16f742&scoped=true"
import script from "./LoginPhone.vue?vue&type=script&lang=js"
export * from "./LoginPhone.vue?vue&type=script&lang=js"
import style1 from "./LoginPhone.vue?vue&type=style&index=1&id=6a16f742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a16f742",
  null
  
)

export default component.exports